import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowRefreshIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M4.97996 4.98C6.84996 3.11 9.34995 2.07 12 2.07C13.68 2.07 15.3 2.49 16.74 3.27L15.68 4.33C15.34 4.65 15.51 5.27 15.96 5.38L21.12 6.76C21.56 6.9 22.02 6.44 21.89 5.99L20.51 0.83C20.4 0.38 19.78 0.21 19.46 0.55L18.2 1.81C16.34 0.69 14.22 0.0799999 12 0.0799999C8.80996 0.0799999 5.81996 1.32 3.56996 3.57C1.00996 6.13 -0.240045 9.67 0.139955 13.27C0.199955 13.82 0.699956 14.22 1.23996 14.16C1.78996 14.1 2.18996 13.61 2.12996 13.06C1.80996 10.06 2.84996 7.12 4.97996 4.99V4.98Z"
        fill={color}
      />
      <path
        d="M23.86 10.73C23.8 10.18 23.32 9.79 22.76 9.84C22.21 9.9 21.81 10.39 21.87 10.94C22.19 13.94 21.15 16.88 19.02 19.01C17.15 20.89 14.65 21.92 12 21.92C10.32 21.92 8.70003 21.5 7.26003 20.72L8.32003 19.66C8.66003 19.34 8.49003 18.72 8.04003 18.61L2.88003 17.23C2.43003 17.09 1.98003 17.55 2.11003 18L3.49003 23.16C3.60003 23.61 4.21003 23.78 4.54003 23.44L5.80003 22.18C7.65003 23.31 9.77003 23.92 11.99 23.92C15.17 23.92 18.17 22.68 20.42 20.43C22.98 17.87 24.23 14.33 23.85 10.73H23.86Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowRefreshIcon.displayName = 'ArrowRefreshIcon';
